// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import MenuBaseItem from './MenuBaseItem';

/**
 * `MenuItem` component.
 */
const MenuItem = ({ baseClassName, className, children, onClick, active, disabled, icon, label, ...props }) => (
    <MenuBaseItem
        className={classNames(
            baseClassName,
            className,
            {
                [`${baseClassName}--active`]: active,
                [`${baseClassName}--disabled`]: disabled,
            }
        )}
        onClick={e => {
            if (onClick && !disabled) {
                onClick(e);
            }
        }}
        tabIndex="0"
        icon={icon}
        label={label}
        {...props}
    >
        {children}
    </MenuBaseItem>
);

MenuItem.propTypes = {
    /**
     * Whether item is active.
     */
    active: PropTypes.bool,
    /**
     * Whether item is disabled.
     */
    disabled: PropTypes.bool,
    /**
     * Icon
     */
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element,
    ]),
    /**
     * Right label of item.
     */
    label: PropTypes.node,
    /**
     * Content of the `MenuItem`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
    /**
     * @ignore
     */
    onClick: PropTypes.func,
};

MenuItem.defaultProps = {
    active: false,
    disabled: false,
    icon: null,
    label: null,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}menu__item`,
    onClick: null,
};

export default MenuItem;



// WEBPACK FOOTER //
// ./components/Menu/MenuItem.js